import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const FilterFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function FilterFilled({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <g fill="currentColor">
          <path d="M22 3.5H2v3h20v-3ZM17.46 10.5H6.55v3h10.91v-3ZM14.92 17.5H9.08v3h5.84v-3Z" />
        </g>
      </svg>;
}) as ForwardedIconComponent);
export default FilterFilled;